import topic from '../topic';
export const moudAPI = {
  getmouds: topic.moudTopic + '/get_mouds',
  addMoud: topic.moudTopic + '/add_mould',
  judgeMoudMtrlNo: topic.moudTopic + '/judge_moud_mtrl_no',
  getMoudById: topic.moudTopic + '/get_moud_by_id',
  deleteMoudCodeByIds: topic.moudTopic + '/delete_moud_by_ids',
  editmoud: topic.moudTopic + '/edit_moud'
};
